module.exports = __webpack_public_path__ + "img/icon_phone.c063c0d2.svg";